import { useTheme } from '@mui/material/styles';
import { useContext } from 'react';

import ApprovalCardElevationContext from './ApprovalCardElevationContext';

export default function useApprovalCardShadow() {
  const theme = useTheme();
  const isElevated = useContext(ApprovalCardElevationContext);

  return isElevated ? theme.shadows[1] : undefined;
}
